module.exports = __webpack_public_path__ + "public/images/caught-up-star.53d01d8d70d1295e176ff2f8a2a67c5e.png";